import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601 } from '../../../../../../../../../utils';
import { CustomerMembership } from '../../../../../../../../../models/membership';
import { ListResponse } from '../../../../../../../../../models/list-response';
import { CustomerRelation } from '../../../../../../../../../models/customer';

@Component({
  selector: 'app-reassign-customer-membership',
  templateUrl: './reassign-customer-membership.component.html',
  styleUrls: ['./reassign-customer-membership.component.css']
})
export class ReassignCustomerMembershipComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public relationsList: ListResponse<CustomerRelation>;

  public selectedCustomerId: number = null;

  public loadingRelations = false;

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    this.loadRelations();
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  /**
   * Load the relations for the membership's owner.
   */
  private loadRelations() {
    this.loadingRelations = true;

    this.customerService
      .getCustomerRelations(this.membership.owner_id, 1, 100)
      .then(response => { this.relationsList = response; })
      .catch(reason => {
        this.serverErrorEvent.emit(reason.status);
      })
      .finally(() => { this.loadingRelations = false; });
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    if (!this.selectedCustomerId) {
      this.errorMessage = 'Please select a customer.';
      this.loadingEvent.emit(false);
      return;
    }

    this.customerService
      .reassignCustomerMembership(
        this.membership.id,
        this.selectedCustomerId
      )
      .then(() => {
        this.savedCallback('Membership reassigned successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to reassign this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
